import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectCards } from 'swiper/modules';

const swiperConfig = {
    modules: [Navigation, Pagination, Autoplay, EffectCards],
    slidesPerView: 1,
    spaceBetween: 22,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
}

document.addEventListener('DOMContentLoaded', () => {
     const $homeHeaderVisual = document.querySelector('.headervisual--home');
    if ($homeHeaderVisual) {
        const totalSlides = $homeHeaderVisual.querySelectorAll('.swiper-slide').length;
        const $swiper = $homeHeaderVisual.querySelector('.swiper');
        const homeHeaderVisualSwiper = new Swiper($swiper, {
            ...swiperConfig,
            spaceBetween: 0,
            autoplay: {
                delay: 8000,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1008: {
                    slidesPerView: 3,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    const realTotal = Math.round(totalSlides / swiper.params.slidesPerView)
                    return `${current} / ${realTotal}`;
                }
            }
        });
    }

    const $widgetsReview = document.querySelectorAll('.widget-review');
    $widgetsReview.forEach($widgetReview => {
        const totalSlides = $widgetReview.querySelectorAll('.swiper-slide').length;
        const $swiper = $widgetReview.querySelector('.swiper');
        const widgetReviewSwiper = new Swiper($swiper, {
            ...swiperConfig,
            effect: 'cards',
            pagination: {
                el: '.swiper-pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    const realTotal = Math.round(totalSlides / swiper.params.slidesPerView)
                    return `${current} / ${realTotal}`;
                }
            }
        });
    });

    const $widgetsImageVideo = document.querySelectorAll('.widget-image-video');
    $widgetsImageVideo.forEach($widgetImageVideo => {
        const $swiper = $widgetImageVideo.querySelector('.swiper');
        const totalSlides = $widgetImageVideo.querySelectorAll('.swiper-slide').length;
        const widgetImageVideoSwiper = new Swiper($swiper, {
            ...swiperConfig,
            slidesPerView: 1.2,
            loop: true,
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    return `${current} / ${totalSlides}`;
                }
            }
        });
    });

    const $widgetsHighlight = document.querySelectorAll('.widget-highlight');
    $widgetsHighlight.forEach($widgetHighlight => {
        const breakpoint = window.matchMedia('(min-width:1008px)');
        const totalSlides = $widgetHighlight.querySelectorAll('.swiper-slide').length;
        let widgetHighlightSwiper;

        const breakpointChecker = function () {
            if (breakpoint.matches === true) {
                if (widgetHighlightSwiper !== undefined) widgetHighlightSwiper.destroy(true, true);
                return;
            } else if (breakpoint.matches === false) {
                widgetHighlightSwiper = new Swiper($widgetHighlight.querySelector('.swiper'), {
                    ...swiperConfig,
                    slidesPerView: 2.3,
                    spaceBetween: 0,
                    loop: true,
                    centeredSlides: false,
                    breakpoints: {
                        769: {
                            slidesPerView: 3.2
                        }
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            return `${current} / ${totalSlides}`;
                        }
                    }
                });
            }
        };

        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
    });
});
